import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import rootReducer from './reducers';
// import { logRocketReduxMiddleware } from '../utils/logrocket';

const composeEnhancers = composeWithDevTools({});
const middlewares = [thunk];
// if (process.env.NODE_ENV === `development`) {
//   const { logger } = require(`redux-logger`);
//   middlewares.push(logger);
// }

// Initialize store
export const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares))
    // composeEnhancers(applyMiddleware(...middlewares, ...logRocketReduxMiddleware))
);

export const persistor = persistStore(store);

export const StoreProvider = props => {
    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>{props.children}</PersistGate>
        </Provider>
    );
};
